import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Priority } from '../model/Priority';
import { ViewScheduledInterviewSerializer } from '../model/serializer/view-interview-scheduled-list'

import { environment } from '@environments/environment';
import { ViewScheduledInterview } from '@app/model/viewScheduledInterview';

@Injectable({ providedIn: 'root' })
export class ViewScheduledInterviewService extends ApiService<ViewScheduledInterview> {

  // Inject a separate HttpClient just for Excel
  constructor(httpClient: HttpClient, private httpForExcel: HttpClient) {
    super(httpClient, environment.apiUrl, 'interview/job', new ViewScheduledInterviewSerializer());
  }

  // exportInterviewExcel(jobId: string, applicant?: string, status?: string): Observable<Blob> {
  //   const url = `${environment.apiUrl}/interview/job/${jobId}/excel`;

  //   const params: any = {};
  //   if (applicant) params.applicant = applicant;
  //   if (status) params.status = status;

  //   // Use the separate HttpClient for Excel
  //   return this.httpForExcel.get(url, { params, responseType: 'blob' });
  // }

  exportInterviewExcel(jobId: string, applicant?: string, status?: string): Observable<Blob> {
  const url = `${environment.apiUrl}/interview/job/${jobId}/excel`;

  let params = new HttpParams();
  if (applicant) params = params.set('applicant', applicant);
  if (status) params = params.set('status', status);

  // Properly typed for Blob
  return this.httpForExcel.get(url, {
    params,
    responseType: 'blob' // <- DO NOT assert as 'json'
  });
}

  exportInterviewPdf(jobId: string, applicant?: string, status?: string): Observable<Blob> {
  const url = `${environment.apiUrl}/interview/job/${jobId}/pdf`;

  const params: any = {};
  if (applicant) params.applicant = applicant;
  if (status) params.status = status;

  return this.httpForExcel.get(url, { params, responseType: 'blob' });
  } 

}
